import script from "./OrderCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCreate.vue?vue&type=script&setup=true&lang=js"

import "./OrderCreate.vue?vue&type=style&index=0&id=33ab186e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33ab186e"]])

export default __exports__